<template>
  <div class="bg-white borderd">
    <div class="px-10 py-2 mx-auto mt-0">
      <tabs>
        <tab name="Api" :selected="true">
          <ApiResources />
        </tab>
        <tab name="Identity" :selected="false">
          <IdentityResources />
        </tab>
      </tabs>
    </div>
  </div>
</template>

<script>
import Tabs from "@/components/Tabs";
import Tab from "@/components/Tab";
import ApiResources from "./ApiResources";
import IdentityResources from "./IdentityResources";

export default {
  name: "clientresources",
  components: { tabs: Tabs, tab: Tab, ApiResources, IdentityResources }
};
</script>
